import { render, staticRenderFns } from "./ItemDropdownWrap.vue?vue&type=template&id=24d5cd69&scoped=true&"
import script from "./ItemDropdownWrap.vue?vue&type=script&lang=js&"
export * from "./ItemDropdownWrap.vue?vue&type=script&lang=js&"
import style0 from "./ItemDropdownWrap.vue?vue&type=style&index=0&id=24d5cd69&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5cd69",
  null
  
)

export default component.exports